import { animate, state, style, transition, trigger } from '@angular/animations';
import { Location } from '@angular/common';
import { Component, DoCheck, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/primeng';
import { CODIGO_CENTRUS, DESABILITAR_MENU_ATUALIZAR_INFORMACOES_CONTATOS, DESCRICAO_CARD, INSTITUCIONAL_DOCUMENTO_SIGLA, ITEM_MENU_ACESSO_CONSULTA, ITENS_MENU_PAI, MODO_PERSPECTIVA_ITENS_MENU_USUARIO } from '../../../../../app.constants';
import { AcessoLinksDocumentosService } from '../../../../institucional/acesso-links-documentos/service/acesso-links-documentos.service';
import { CardModel } from '../../../models/card.model';
import { FuncoesCardMenu } from '../../../util/funcaoes-card-menu/funcoes-card-menu';
import { StorafeUtil } from '../../../util/storasge.util';
import { MenuLateralParaleloComponent } from '../menu-lateral-paralelo.component';


@Component({
    /* tslint:disable:component-selector */
    selector: '[app-submenu]',
    /* tslint:enable:component-selector */
    template: `
         <ng-template ngFor let-child let-i="index" [ngForOf]="(root ? item : item.items)">
             <li [ngClass]="{'active-menuitem': isActive(i), 'disabled': disabledAtualizarInfContatos}" [class]="child.badgeStyleClass">
                 <a [href]="child.url||'#'" (click)="itemClick($event,child,i)" *ngIf="!child.routerLink"
                 [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target"
                     (mouseenter)="hover=true" (mouseleave)="hover=false">
                     <i [ngClass]="child.icon"></i>
                     <span>{{child.label}}</span>
                     <i class="fa fa-fw fa-angle-down layout-submenu-toggler" *ngIf="child.items"></i>
                     <span class="menuitem-badge" *ngIf="child.badge">{{child.badge}}</span>
                 </a>

                 <a (click)="itemClick($event,child,i)" *ngIf="child.routerLink"
                     [routerLink]="" routerLinkActive="active-menuitem-routerlink"
                    [routerLinkActiveOptions]="{exact: true}" [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target"
                    [class.disabled]="disabled ? true: null"
                     (mouseenter)="hover=true" (mouseleave)="hover=false">
                     <i [ngClass]="child.icon"></i>
                     <span>{{child.label}}</span>
                     <i class="fa fa-fw fa-angle-down" *ngIf="child.items"></i>
                     <span class="menuitem-badge" *ngIf="child.badge">{{child.badge}}</span>
                 </a>
                 <ul app-submenu [item]="child" *ngIf="child.items" [visible]="isActive(i)" [reset]="reset"
                     [@children]="isActive(i) ? 'visible' : 'hidden'"></ul>
             </li>
         </ng-template>
     `,
    styles: ['a:hover { color: gray !importent; }'],
    animations: [
        trigger('children', [
            state('visible', style({
                height: '*'
            })),
            state('hidden', style({
                height: '0px'
            })),
            transition('visible => hidden', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hidden => visible', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class AppMenuLateralSubComponent implements DoCheck, OnDestroy {

    @Input() item: MenuItem;

    @Input() root: boolean;

    @Input() visible: boolean;

    _reset: boolean;

    activeIndex: number;

    hover: boolean;

    disabled = false;
    disabledAtualizarInfContatos: boolean;

    constructor(
        public router: Router,
        public location: Location,
        public acessoLinksDocumentosService: AcessoLinksDocumentosService,
        public menuLateralParaleloComponent: MenuLateralParaleloComponent,
        private funcoesCardMenu: FuncoesCardMenu) {
    }


    ngDoCheck(): void {
        this.getDadosSesseionStorage();

    }
    ngOnDestroy(): void {
        this.getDadosSesseionStorage();
    }

    getDadosSesseionStorage(): void {
        this.verificarAtualizarInfContato();
        try {
            const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(MODO_PERSPECTIVA_ITENS_MENU_USUARIO);
            (Boolean(recuperandoObjeto)) ?
                (this.disabled = Boolean(recuperandoObjeto))
                : this.disabled = false;

        } catch (error) {
            console.error(error);
        }
    }



    private verificarAtualizarInfContato(): Boolean {
        const atualizarInfoContatos = StorafeUtil.recuperarSessionStorage(DESABILITAR_MENU_ATUALIZAR_INFORMACOES_CONTATOS);

        return (atualizarInfoContatos) ?
            (this.disabledAtualizarInfContatos = Boolean(atualizarInfoContatos))
            : this.disabledAtualizarInfContatos = false;
    }

    //

    itemClick(event: Event, item: MenuItem, index: number) {
        //   avoid processing disabled items
        if (item.disabled) {
            event.preventDefault();
            return true;
        }


        this.acessoLinksDocumentosService.mudouLayout.emit(true);

        if (item.routerLink.length > 1) {
            StorafeUtil.gravaSessionStorage(INSTITUCIONAL_DOCUMENTO_SIGLA, new CardModel(item['routerLink'], item['sigla'], item['label'], null, item['tpTela'])),
                StorafeUtil.gravaSessionStorage(ITEM_MENU_ACESSO_CONSULTA, item['sigla'])
        };

        const sigla = item['sigla'];
        (item.routerLink.length > 1)
            ? this.direcionar(new CardModel(item['routerLink'], item['sigla'], item['label'], null, item['tpTela']))
            : this.garavarCaminho(sigla)

        // !this.disabled && StorafeUtil.limparSessionStorage(CODIGO_CENTRUS);


        //   activate current item and deactivate active sibling if any
        if (item.routerLink || item.items || item.command || item.url) {
            this.activeIndex = (this.activeIndex === index) ? null : index;
        }

        this.clearCdCentrus();

        //   execute command
        if (item.command) {
            item.command({ originalEvent: event, item: item });
        }

        //   prevent hash change
        if (item.items || (!item.url && !item.routerLink)) {
            setTimeout(() => {
                this.menuLateralParaleloComponent.layoutMenuScrollerViewChild.moveBar();
            }, 450);
            event.preventDefault();
        }


    }


    private clearCdCentrus() {
        const modoConsultadoUusario = StorafeUtil.recuperarSessionStorage(MODO_PERSPECTIVA_ITENS_MENU_USUARIO);
        if (!modoConsultadoUusario) { StorafeUtil.limparSessionStorage(CODIGO_CENTRUS); };
    }

    private garavarCaminho(sigla: string) {
        return (ITENS_MENU_PAI.find(item => item === sigla)) && (StorafeUtil.gravaSessionStorage(DESCRICAO_CARD, sigla));
    }

    isActive(index: number): boolean {
        return this.activeIndex === index;
    }

    @Input() get reset(): boolean {
        return this._reset;
    }

    set reset(val: boolean) {
        this._reset = val;
    }

    direcionar(dadosCards: CardModel): void {
        this.funcoesCardMenu.direcionar(dadosCards);
    }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/layout/menu-lateral/menu-lateral-sub/menu-lateral-sub.component.ts